module.exports = __webpack_public_path__ + "static/grand-footer-d6880fa63f0e1db6b2ad092ac345f916.png";